import { Settings } from './settings';
export class NewUser {
    firstname: string;
    lastname: string;
    _id: string;
    username: string;
    password: string;
    email: string;
    reenterpassword: string;
    comfirmpassword: string;
    token: string;
    mobile: string;
    district: string = 'දිස්ත්‍රික්කය';
    grade : string;
    billingEmail: string;
    points: string;
    authenticationType: string;
    billingMobile: any;
    accountNo: string;
    image: any;
    setting: Settings;
    shouldPayRegistrationFee: boolean;
    registrationFee: number
    userSubscription: UserSubscritpion;

    constructor(obj) {
        this.firstname = obj.firstname;
        this.lastname = obj.lastname;
        this._id = obj._id;
        this.district = obj.district;
        this.username = obj.username;
        this.password = obj.password;
        this.email = obj.email;
        this.mobile = obj.mobile;
        this.reenterpassword = obj.reenterpassword;
        this.comfirmpassword = obj.comfirmpassword;
        this.token = obj.token;
        this.billingEmail = obj.billingEmail;
        this.billingMobile = obj.billingMobile;
        this.image = obj.image;
        this.setting = obj.setting? obj.setting: new Settings({});
        this.authenticationType = obj.authenticationType;
        this.accountNo = obj.accountNo;
        this.points = obj.points;
        this.grade = obj.grade;
        // this.shouldPayRegistrationFee = obj.shouldPayRegistrationFee;
        this.registrationFee = obj.registrationFee;
        this.shouldPayRegistrationFee = true;
        // this.registrationFee = 100;
        this.userSubscription = obj.userSubscription;
    }

    public getDisplayName() {
        if (this.firstname && this.lastname) {
            return this.firstname;
        }

        if (!this.firstname && !this.lastname) {
            return this.mobile;
        }

        if (!this.firstname && this.lastname) {
            return this.lastname;
        }
        if (this.firstname && !this.lastname) {
            return this.firstname;
        }
        return '';
    }

    public getProfileImage() {
        if (this.image) {
            return this.image;
        } else {
            return '/assets/img/default-avatar.svg';
        }
    }

}

export class UserSubscritpion{
    subscriptionPackageId: string;
    status: string
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/newUser.ts